// Unlisted soft-launch URL segment for the gifting page (random so it can't be
// guessed). Literal copy: next.config.js headers.
export const GIFTING_SLUG = 'x5i28rjjuhg1';
export const GIFTING_PATH = `/${GIFTING_SLUG}`;
